import { Snackbar, styled, type SnackbarProps } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import DeleteOutlinedButton from './DeleteOutlinedButton';

export type SnackbarAlertProps = Omit<SnackbarProps, 'children'> & {
  children?: React.ReactNode;
  severity?: 'error' | 'warning' | 'info' | 'success';
};

const AlertStyled = styled(Alert)({
  '& .close': {
    position: 'absolute',
    right: -6,
    top: -6,
  },
});

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({
  children,
  severity,
  onClose,
  ...props
}) => (
  <Snackbar
    style={{ position: 'absolute' }}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    autoHideDuration={2000}
    onClose={onClose}
    {...props}
  >
    <AlertStyled
      severity={severity}
      elevation={1}
      action={
        <DeleteOutlinedButton
          className="close"
          onClick={event => onClose?.(event, 'clickaway')}
        />
      }
    >
      {children}
    </AlertStyled>
  </Snackbar>
);
export default SnackbarAlert;
